import React from "react";

export function WhySection({ t }) {
  return (
    <section className="py-12 lg:py-28 bg-[#292524] text-white relative overflow-hidden" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="overline mb-3 !text-[#E5A93D]">ATS REALITY</div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl leading-tight">
            {t.why.title}
          </h2>
        </div>
        <div className="lg:col-span-7 space-y-4 lg:space-y-5 text-base sm:text-lg text-white/80 leading-relaxed">
          <p>{t.why.p1}</p>
          <p>{t.why.p2}</p>
          <p className="text-white">{t.why.p3}</p>
        </div>
      </div>
    </section>
  );
}
